import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { SectionLayout } from './section-layout';
import { ComponentQueryLoader } from '../../../../shared/component-query-loader';
import { CasesIdentityVerificationV1SectionLayoutContainerIdentityVerificationCaseV1Document } from '../../../../../generated';

interface SectionLayoutContainerProps {
  pageLayouts: any[];
  isApplicantSection?: boolean;
}

export const SectionLayoutContainer: React.FC<SectionLayoutContainerProps> = (props) => {
  const params = useParams();
  const { caseId } = params;

  const { data: caseStateData, loading: caseStateLoading, error: caseStateError } = useQuery(CasesIdentityVerificationV1SectionLayoutContainerIdentityVerificationCaseV1Document,
    {
      variables: {
        identityVerificationCaseV1Id: caseId,
      },
    }
  );

  return (
    <ComponentQueryLoader
      error={caseStateError}
      loading={caseStateLoading}
      hasData={caseStateData !== undefined}
      hasDataComponent={
        <SectionLayout caseState={caseStateData?.identityVerificationCaseV1?.state ?? ""} pageLayouts={props.pageLayouts} caseId={caseId ?? ""} caseName={caseStateData?.identityVerificationCaseV1?.caseName ?? ""} isApplicantSection={props.isApplicantSection}/>
      }
    />
  );
};
